/* Grub — Night Sky.  Talks to Shopify's real /cart AJAX API. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- money ---- */
  function money(cents) {
    var fmt = (window.GRUB && window.GRUB.money) || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    var parts = amt.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  /* ---- toast ---- */
  var tid;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(tid); tid = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---- drawer ---- */
  var drawer = $('#cartDrawer'), scrim = $('#scrim'), lastFocus = null;
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    var c = $('#cartClose'); c && c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true');
    scrim && scrim.classList.remove('on');
    lastFocus && lastFocus.focus();
  }

  /* ---- render the drawer from Shopify's cart object ---- */
  // Same control the cart page renders in Liquid, so the drawer and the page
  // behave identically. Keyed on the LINE key, never the variant id — one
  // variant can occupy two lines and the id would change the wrong one.
  function qtyHtml(key, q) {
    return '<div class="qty" role="group" aria-label="Quantity">' +
      '<button type="button" class="qty__b" data-qstep="-1" data-qkey="' + key + '" aria-label="Reduce quantity">\u2212</button>' +
      '<input class="qty__i" type="number" min="0" step="1" inputmode="numeric" value="' + q +
      '" data-qinput="' + key + '" aria-label="Quantity">' +
      '<button type="button" class="qty__b" data-qstep="1" data-qkey="' + key + '" aria-label="Increase quantity">+</button></div>';
  }

  var qtyBusy = {};
  function setQty(key, q, fromDrawer) {
    if (qtyBusy[key]) return Promise.resolve();
    qtyBusy[key] = true;
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, q) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        drawCart(cart);          // keeps the drawer and the header count honest
        paintCartPage(cart);     // and the /cart page, if that is where we are
      })
      .catch(function () { toast('Could not update the cart — try again'); })
      .finally(function () { qtyBusy[key] = false; });
  }

  // Repaint the /cart page from the cart JSON instead of reloading. A reload
  // cancels the request that caused it, which is how a typed quantity could end
  // up applied only partly. Falls back to a reload only if the markup it needs
  // is not there.
  function paintCartPage(cart) {
    var rows = document.querySelectorAll('[data-line]');
    if (!rows.length) return;
    var live = {};
    cart.items.forEach(function (it) { live[it.key] = it; });
    rows.forEach(function (row) {
      var it = live[row.dataset.line];
      if (!it) { row.remove(); return; }                       // quantity taken to zero
      var lp = row.querySelector('[data-line-price]');
      if (lp) lp.textContent = money(it.line_price);
      var qi = row.querySelector('[data-qinput]');
      if (qi) qi.value = it.quantity;
      row.querySelectorAll('button,input').forEach(function (el) { el.disabled = false; });
    });
    var tot = document.querySelector('[data-cart-total]');
    if (tot) tot.textContent = money(cart.total_price);
    drawShipbar(cart);
    if (!cart.items.length) location.reload();                 // show the empty state
  }

  /* ---- free-shipping bar ---- */
  function drawShipbar(cart) {
    document.querySelectorAll('[data-shipbar]').forEach(function (bar) {
      var th = parseInt(bar.dataset.threshold, 10) || 0; if (!th) return;
      var left = th - cart.total_price, pct = Math.min(100, Math.round(cart.total_price * 100 / th));
      var txt = bar.querySelector('[data-shipbar-text]'), fill = bar.querySelector('[data-shipbar-fill]');
      if (txt) txt.innerHTML = left > 0 ? 'You\'re <strong>' + money(left) + '</strong> away from free US shipping.' : '<strong>Free US shipping</strong> is yours.';
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('shipbar--done', left <= 0);
    });
  }

  function drawCart(cart) {
    var dot = $('#cartDot');
    if (dot) { dot.textContent = cart.item_count; dot.classList.toggle('on', cart.item_count > 0); }
    var body = $('#cartBody'); if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">' + (body.dataset.empty || 'Nothing in here yet.') + '</p>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title + ' &middot; ' : '';
        return '<div class="ci">' + img +
          '<div style="flex-grow:1"><div class="ci__t">' + it.product_title + '</div>' +
          '<div class="ci__m">' + vt + money(it.price) + ' each</div>' +
          qtyHtml(it.key, it.quantity) + '</div>' +
          '<button class="iconbtn" data-rm="' + it.key + '" aria-label="Remove ' + it.product_title.replace(/"/g, '') + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7A6551" stroke-width="2"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>';
      }).join('');
    }
    var tot = $('#cartTotal'); if (tot) tot.textContent = money(cart.total_price);
    drawShipbar(cart);
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(drawCart);
  }

  /* ---- email me my cart ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-cart-save]'); if (!f) return;
    e.preventDefault();
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var link = location.origin + '/cart/' + cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      var n = f.querySelector('[data-cart-link]'); if (n) n.value = 'Saved cart: ' + link;
      return fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' });
    }).then(function (res) {
      if (!res || /challenge/.test(res.url)) { f.submit(); return; }          // spam check: let the browser handle it
      f.hidden = true;
      var ok = f.parentNode.querySelector('[data-cart-save-ok]'); if (ok) ok.hidden = false;
    }).catch(function () { f.submit(); });
  });

  /* ---- add to cart, without leaving the page ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form)))
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || 'Could not add that'); return; }
        return fetchCart().then(function () { toast(res.j.product_title + ' added'); openCart(); });
      })
      .catch(function () { toast('Could not reach the cart — try again'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---- remove a line ---- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]'); if (!rm) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.dataset.rm, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(drawCart);
  });

  /* ---- change a line's quantity ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qstep]'); if (!b) return;
    e.preventDefault();
    var wrap = b.closest('.qty');
    var input = wrap && wrap.querySelector('[data-qinput]');
    var now = input ? parseInt(input.value, 10) || 0 : 0;
    var next = now + parseInt(b.dataset.qstep, 10);
    if (next < 0) return;
    if (input) input.value = next;                       // optimistic, so it feels instant
    wrap.querySelectorAll('button,input').forEach(function (el) { el.disabled = true; });
    setQty(b.dataset.qkey, next, !!b.closest('#cartBody'));
  });

  // Enter inside the cart form would otherwise submit it. The form post IS a
  // working fallback, but a full round trip for one keystroke is worse than
  // handling it here, so intercept and let the fetch do it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var i = e.target.closest('[data-qinput]'); if (!i) return;
    e.preventDefault();
    i.blur();
  });

  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-qinput]'); if (!i) return;
    var n = parseInt(i.value, 10);
    if (isNaN(n) || n < 0) { n = 0; i.value = 0; }
    setQty(i.dataset.qinput, n, !!i.closest('#cartBody'));
  });

  /* ---- header ---- */
  /* The menu is a full-screen overlay now, so it has to behave like one:
     lock the page behind it or the body scrolls under your finger, give it a
     close control, and let Escape out. */
  var burger = $('#burger');
  function setMenu(open) {
    var m = $('#mnav'); if (!m) return;
    m.classList.toggle('on', open);
    document.body.classList.toggle('mnav-open', open);
    burger && burger.setAttribute('aria-expanded', String(open));
    if (open) { m.focus({ preventScroll: true }); }
    else { burger && burger.focus(); }
  }
  burger && burger.addEventListener('click', function () {
    setMenu(!$('#mnav').classList.contains('on'));
  });
  var mx = $('#mnavClose'); mx && mx.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  /* a tap on any link inside closes it, so returning via the back button
     does not land on a page with the menu still covering it */
  var mnavEl = $('#mnav');
  mnavEl && mnavEl.addEventListener('click', function (e) {
    if (e.target.closest('a')) setMenu(false);
  });
  var cartBtn = $('#cartBtn');
  cartBtn && cartBtn.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openCart); });
  var cc = $('#cartClose'); cc && cc.addEventListener('click', closeCart);
  scrim && scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---- product page ---- */
  var sel = $('#variantSelect');
  if (sel) {
    var qty = 1;
    function currentVariant() { return sel.options[sel.selectedIndex]; }
    function syncBuy() {
      var o = currentVariant();
      var q = $('#qVal'), qi = $('#qInput'), add = $('#pdpAdd'), price = $('#pdpPrice');
      if (q) q.textContent = qty;
      if (qi) qi.value = qty;
      if (price) price.textContent = o.dataset.price;
      if (add) {
        var avail = o.dataset.available === 'true';
        add.disabled = !avail;
        add.innerHTML = avail
          ? 'Add to cart<span class="pricebit"> &mdash; ' + o.dataset.price + '</span>'
          : 'Back soon';
      }
    }
    $$('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = b.dataset.opt;
        $$('[data-opt="' + pos + '"]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        // the page takes the colour of the flavour chosen
        var pdp = document.querySelector('.pdp');
        if (pdp && b.dataset.colour) pdp.style.setProperty('--fl', b.dataset.colour);
        // the banner is the line printed on THAT bag — swap it with the flavour
        // NOT swapping the hero to the pouch back: it is a nutrition panel on a
        // white cut-out, which is neither appetising nor a fit for the tinted
        // panel. Its CONTENT is typeset below instead, at web quality.
        // The flavour's paragraph, however, does follow the choice.
        var fs = document.getElementById('flavourStory');
        if (fs && b.dataset.story) { fs.textContent = b.dataset.story; }
        var ob = document.getElementById('offBag');
        if (ob && b.dataset.colour) ob.style.setProperty('--fl', b.dataset.colour);
        var pl = document.getElementById('packLine');
        if (pl) {
          var line = b.dataset.line || '';
          pl.textContent = line;
          pl.classList.toggle('is-on', !!line);
          if (line) { pl.classList.remove('flip'); void pl.offsetWidth; pl.classList.add('flip'); }
        }
        var chosen = $$('[data-opt]').filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })
          .sort(function (a, c) { return a.dataset.opt - c.dataset.opt; })
          .map(function (x) { return x.dataset.val; }).join(' / ');
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].textContent.trim() === chosen) { sel.selectedIndex = i; break; }
        }
        syncBuy();
      });
    });
    var qm = $('#qMinus'), qp = $('#qPlus');
    qm && qm.addEventListener('click', function () { qty = Math.max(1, qty - 1); syncBuy(); });
    qp && qp.addEventListener('click', function () { qty = Math.min(99, qty + 1); syncBuy(); });
    var first = document.querySelector('[data-opt][aria-pressed="true"]');
    var pdp0 = document.querySelector('.pdp');
    if (first && pdp0 && first.dataset.colour) pdp0.style.setProperty('--fl', first.dataset.colour);
    syncBuy();
  }

  /* ---- gallery ---- */
  $$('[data-full]').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('[data-full]').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      t.setAttribute('aria-selected', 'true');
      var img = $('#galImg'); if (img) { img.removeAttribute('srcset'); img.src = t.dataset.full; }
    });
  });

  fetchCart();
})();

/* ---- blog hub: search via Shopify Predictive Search (covers every article) ---- */
(function () {
  var box = document.getElementById('hubq');
  var results = document.getElementById('hubresults');
  if (!box || !results) return;
  var library = document.getElementById('hublibrary');
  var status  = document.getElementById('hubstatus');
  var clear   = document.getElementById('hubclear');
  var base    = results.dataset.searchUrl || '/search/suggest';
  var seq = 0, t;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function card(a){
    var img = a.image
      ? '<span class="acard__img"><img src="'+esc(a.image)+'" width="320" height="220" alt="" decoding="async"></span>'
      : '<span class="acard__img"></span>';
    var date = a.published_at ? new Date(a.published_at).toLocaleDateString(undefined,{day:'2-digit',month:'short',year:'numeric'}) : '';
    return '<a class="acard" href="'+esc(a.url)+'">'+img+
      '<span class="acard__body"><span class="acard__date">'+esc(date)+'</span>'+
      '<span class="acard__title">'+esc(a.title)+'</span></span></a>';
  }

  function pcard(p){
    var img = p.featured_image && p.featured_image.url
      ? '<span class="acard__img"><img src="'+esc(p.featured_image.url)+'" width="320" height="220" alt="" decoding="async"></span>'
      : '<span class="acard__img"></span>';
    // p.price arrives in cents as a string on some shops and a number on others
    var cents = (p.price === 0 || p.price) ? Number(p.price) : null;
    var price = (cents || cents === 0) ? '$' + (cents / 100).toFixed(2) : '';
    return '<a class="acard acard--prod" href="'+esc(p.url)+'">'+img+
      '<span class="acard__body"><span class="acard__date">In the shop</span>'+
      '<span class="acard__title">'+esc(p.title)+'</span>'+
      (price ? '<span class="acard__price">'+esc(price)+'</span>' : '')+
      '</span></a>';
  }

  function reset(){
    results.hidden = true; results.innerHTML = '';
    if (library) library.hidden = false;
    status.textContent = ''; clear.hidden = true;
  }

  function run(){
    var q = box.value.trim();
    clear.hidden = !q;
    if (q.length < 2) { reset(); return; }
    var mine = ++seq;
    status.textContent = 'Searching…';
    // Products as well as guides. Someone typing "sliced biltong" into the
    // library search wants the bag, not an essay about the bag — and before
    // this they only ever got the essay.
    var url = base + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=article,product&resources[limit]=20' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (mine !== seq) return;                      // a newer keystroke already won
        var res  = (j.resources && j.resources.results) || {};
        var arts = res.articles || [];
        var prods = res.products || [];
        var html = '';
        if (prods.length) html += prods.map(pcard).join('');
        if (arts.length)  html += arts.map(card).join('');
        // On no matches, keep the whole library on screen. Hiding it left a
        // near-empty page with one small line of text on it, which reads as a
        // broken site rather than as "nothing found".
        var nothing = !html;
        if (library) library.hidden = !nothing ? true : false;
        results.hidden = false;
        results.innerHTML = html ||
          '<p class="notice">Nothing matched “' + esc(q) + '”. Everything is still below — or try a shorter word: “biltong”, “jerky”, “storage”.</p>';

        var bits = [];
        if (prods.length) bits.push(prods.length + (prods.length === 1 ? ' product' : ' products'));
        if (arts.length)  bits.push(arts.length + (arts.length === 1 ? ' guide' : ' guides'));
        status.textContent = bits.length
          ? bits.join(' and ') + ' matching “' + q + '”'
          : 'No matches for “' + q + '”';
      })
      .catch(function(){ if (mine === seq) status.textContent = 'Search is unavailable right now.'; });
  }

  box.addEventListener('input', function(){ clearTimeout(t); t = setTimeout(run, 220); });
  box.addEventListener('search', run);
  clear.addEventListener('click', function(){ box.value=''; reset(); box.focus(); });
})();

/* ── Subscription selector ────────────────────────────────────────────────
   Selling plans existed on three products and the theme never rendered them,
   so nobody could subscribe. The hidden selling_plan input starts DISABLED —
   a disabled field is not submitted — so "One time" posts precisely what the
   form posted before this existed. Only picking a plan enables it. */
(function () {
  var wrap = document.querySelector('.flavours.subs');
  var input = document.getElementById('planInput');
  if (!wrap || !input) return;
  wrap.addEventListener('click', function (e) {
    var b = e.target.closest('button.fl');
    if (!b || !wrap.contains(b)) return;
    wrap.querySelectorAll('button.fl').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    b.setAttribute('aria-pressed', 'true');
    var plan = b.dataset.plan || '';
    if (plan) { input.value = plan; input.disabled = false; }
    else { input.value = ''; input.disabled = true; }
  });
})();
